/**
 * `cn` — class name merger. Combines `clsx` (conditional class names) with
 * `tailwind-merge` (resolves conflicting Tailwind utilities, last-wins).
 * Every component uses this so consumers can override styles via `className`.
 */
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map